export const GET_SIZES = 'sizes/GET_SIZES';
export const GET_SIZES_SUCCESS = 'sizes/GET_SIZES_SUCCESS';
export const GET_SIZES_ERROR = 'sizes/GET_SIZES_ERROR';
